// extracted by mini-css-extract-plugin
module.exports = {"winner_swiper_unity":"winnerSwiper_winner_swiper_unity__BUC1R","winner_list":"winnerSwiper_winner_list__20yXF","winner_swiper_item":"winnerSwiper_winner_swiper_item__u8QVH"};